import {MainRequest} from '../../../Services/common';

export interface NormalLoginSetting {
    lengthMin: number; // 最小长度
    lengthMax: number; // 最大长度
    upperCase: '0' | '1'; // 需要包含大写字母
    expire: number; // 过期时间, 单位天, 0表示永不过期
    lowerCase: '0' | '1'; // 需要包含小写字母
    specificSymbol: '0' | '1'; // 需要包含特殊字符
    numberCase: '0' | '1'; // 需要包含数字
    defaultPassword: string; // 密码
    status: '0' | '1'; // 启用停用
}

/**
 * 获取普通登录设置
 */
export function getNormalLoginSetting() {
    return MainRequest.post<SuccessData<NormalLoginSetting>>(
        '/systemConfig/getNormalLoginSetting',
    ).then(res => res.data.data);
}

export interface NormalLoginSettingForm {
    lengthMin: number; // 最小长度
    lengthMax: number; // 最大长度
    upperCase: '0' | '1'; // 需要包含大写字母
    expire: number; // 过期时间, 单位天, 0表示永不过期
    lowerCase: '0' | '1'; // 需要包含小写字母
    specificSymbol: '0' | '1'; // 需要包含特殊字符
    numberCase: '0' | '1'; // 需要包含数字
    defaultPassword: string; // 密码
    status: '0' | '1'; // 启用停用
}

/**
 * 普通登录设置保存
 * @param data
 */
export function saveNormalLoginSetting(data: NormalLoginSettingForm) {
    return MainRequest.post('/systemConfig/saveNormalLoginSetting', data);
}

export interface PubPwdKey {
    pwd: string;
    status: '0' | '1'; // 启用停用
}

/**
 * 获取动态凭证
 */
export function getPubPwdKey() {
    return MainRequest.post<SuccessData<PubPwdKey>>(
        '/systemConfig/getPubPwdKey',
    ).then(res => res.data.data);
}

/**
 * 刷新动态凭证
 */
export function refreshPubPwdKey() {
    return MainRequest.post('/systemConfig/refreshPubPwdKey');
}

/**
 * 修改动态凭证开启状态
 * @param status
 */
export function changePubKeyStatus(status: string) {
    return MainRequest.post('/systemConfig/changePubKeyStatus', {status});
}
